import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText,
  ListItemSecondaryAction, IconButton, TextField, Button, Tooltip, Divider, Box, Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';

export default function StageManagerDialog({
  open, onClose, stages = [], getStageColor, getContactCountForStage,
  onAddStage, onEditStage, onDeleteStage,
}) {
  const [newStageName, setNewStageName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState('');

  const startEdit = stage => { setEditingId(stage.StageId); setEditingValue(stage.label); };
  const cancelEdit = () => { setEditingId(null); setEditingValue(''); };
  const saveEdit = stage => {
    if (editingValue.trim() && editingValue.trim() !== stage.label) onEditStage(stage, editingValue.trim());
    cancelEdit();
  };
  const handleAdd = () => { if (newStageName.trim()) { onAddStage(newStageName.trim()); setNewStageName(''); } };
  const handleDelete = stage => {
    const count = getContactCountForStage ? getContactCountForStage(stage.label) : 0;
    if (count > 0) return;
    if (window.confirm(`Delete stage "${stage.label}"? This cannot be undone.`)) onDeleteStage(stage);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Manage Stages</DialogTitle>
      <DialogContent>
        <List dense>
          {stages.map(stage => {
            const count = getContactCountForStage ? getContactCountForStage(stage.label) : 0;
            const isEditing = editingId === stage.StageId;
            return (
              <ListItem key={stage.value} divider>
                <span style={{ width: 10, height: 10, borderRadius: '50%', marginRight: 10, flexShrink: 0, backgroundColor: getStageColor ? getStageColor(stage.label, 0) : '#bdbdbd' }} />
                {isEditing ? (
                  <TextField value={editingValue} onChange={e => setEditingValue(e.target.value)} size="small" autoFocus fullWidth />
                ) : (
                  <ListItemText primary={stage.label} secondary={`${count} contact${count === 1 ? '' : 's'}`} />
                )}
                <ListItemSecondaryAction>
                  {isEditing ? (
                    <>
                      <IconButton size="small" onClick={() => saveEdit(stage)}><CheckIcon fontSize="small" style={{ color: '#2e7d32' }} /></IconButton>
                      <IconButton size="small" onClick={cancelEdit}><CloseIcon fontSize="small" /></IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton size="small" onClick={() => startEdit(stage)}><EditIcon fontSize="small" /></IconButton>
                      <Tooltip title={count > 0 ? 'Move all contacts out of this stage first' : 'Delete stage'}>
                        <span>
                          <IconButton size="small" disabled={count > 0} onClick={() => handleDelete(stage)}>
                            <DeleteIcon fontSize="small" style={{ color: count > 0 ? undefined : '#d32f2f' }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
        <Divider style={{ margin: '12px 0' }} />
        <Typography variant="caption" color="textSecondary">Add a new stage</Typography>
        <Box display="flex" alignItems="center" style={{ gap: 8, marginTop: 6 }}>
          <TextField value={newStageName} onChange={e => setNewStageName(e.target.value)} placeholder="e.g. Negotiation" size="small" fullWidth onKeyDown={e => e.key === 'Enter' && handleAdd()} />
          <IconButton size="small" color="primary" onClick={handleAdd} disabled={!newStageName.trim()}><AddIcon /></IconButton>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}